import authentication from "@irati/auth";
import { isUserDOBRequired, userDOBIsWithinRedemptionWindow } from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth";
export var getDealForHomepageBanner = function (taggedDeal, birthdayDeal) {
    return birthdayDeal && isUserDOBRequired(birthdayDeal) && userDOBIsWithinRedemptionWindow(birthdayDeal, authentication.user().dob)
        ? birthdayDeal
        : taggedDeal;
};
